/* eslint-disable react/no-array-index-key */
import React from "react";
import { Row, Col } from "antd";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import useWindowDimensions from "../../helper/viewport";

const NavigationMenuCard = ({ menu }) => {
  const { width } = useWindowDimensions();

  const menuCardStyle = {
    padding: 12,
    borderRadius: 16,
    color: "#fff",
    backgroundColor: "#1B6FBA",
    margin: "0px 12px 12px 0px",
    textAlign: "center",
  };

  return (
    <div
      style={{
        backgroundColor: "#66BCFB",
        borderRadius: 12,
        display: "flex",
        flexFlow: "row",
        flexWrap: "wrap",
        justifyContent: width > 795 ? "space-between" : "center",
      }}
    >
      <div
        style={{
          padding: 16,
        }}
      >
        <div
          className="text-header"
          style={{ color: "#125590", marginBottom: 16 }}
        >
          All Menu
        </div>
        <Row justify={width > 795 ? "start" : "center"}>
          {menu.map((e, idx) => {
            return (
              <Link to={e.path} key={idx}>
                <Col style={menuCardStyle}>
                  <span className="text-default">{e.title}</span>
                </Col>
              </Link>
            );
          })}
        </Row>
        <div
          className="text-secondary"
          style={{ color: "#125590", marginTop: 12 }}
        >
          *Pilih menu untuk menampilkan halaman
        </div>
      </div>
      <img
        src={`${process.env.PUBLIC_URL}/assets/topbar.png`}
        alt="Illustration"
        style={{
          height: 180,
        }}
      />
    </div>
  );
};

NavigationMenuCard.propTypes = {
  menu: PropTypes.array,
};

export default NavigationMenuCard;
